import { noop } from 'lodash-es';
import { put, call, takeLatest } from 'redux-saga/effects';
import {
	setActionLoaderTrue,
	setActionLoaderFalse,
} from '../../reducers/actionLoader';
import {
	setActionError,
	resetActionError,
} from '../../reducers/actionError';
import paymentService from '../../../services/paymentService';
import {
    fetchVpaValidation,
    fetchNeftDetails,
    setNeftDetails,
	fetchMfVpaValidation,
} from '../../reducers/paymentV2';
import { fetch_neft_details, validate_vpa, validate_mf_vpa} from '../../../apis/paymentV2';

function* handleVpaValidation({ payload }) {
	const { Api, sagaCallback = noop, params = {} } = payload;
	try {
		yield put(resetActionError(fetchVpaValidation));
		const response = yield call(validate_vpa, Api, params);
		yield call(sagaCallback, response);
	} catch (error) {
		console.log('error while validating the vpa');
		yield put(
			setActionError({
				isFetchFailed: true,
				actionName: fetchVpaValidation,
			}),
		);
	}
}

function* handleFetchMfVpaValidation({payload}) {
	const { Api, sagaCallback = noop, params = {} } = payload;
	try {
		yield put(resetActionError(fetchMfVpaValidation));
		const response = yield call(validate_mf_vpa, Api, params);
		yield call(sagaCallback, response);
	} catch (error) {
		console.log('error while validating the vpa');
		yield put(
			setActionError({
				isFetchFailed: true,
				actionName: fetchMfVpaValidation,
			}),
		);
	}
}

function* handleFetchNeftDetails({ payload }) {
	const { Api, sagaCallback = noop } = payload;
	try {
		yield put(resetActionError(fetchNeftDetails));
		yield put(setActionLoaderTrue(fetchNeftDetails));
		const response = yield call(fetch_neft_details, Api);
		const formateNeftData = yield call(
			paymentService.formateNeftData,
			response,
		);
		yield put(setNeftDetails(formateNeftData));
		yield call(sagaCallback);
	} catch (error) {
		console.log('error while fetching the neft details');
		yield put(
			setActionError({
				isFetchFailed: true,
				actionName: fetchNeftDetails,
			}),
		);
	} finally {
		yield put(setActionLoaderFalse(fetchNeftDetails));
	}
}

export default function* addFundsPaymentSaga() {
	yield takeLatest(fetchVpaValidation.toString(), handleVpaValidation);
	yield takeLatest(fetchNeftDetails.toString(), handleFetchNeftDetails);
	yield takeLatest(fetchMfVpaValidation.toString(), handleFetchMfVpaValidation);
}
